import { toast } from 'react-toastify';
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import { STATUS_BADGE } from '../../../../../constants/fundings';

function NewFundingStatusForm({ fundingStatus, fundingId, refreshFunding, setSpinner }) {
  const { apiOriginFunding } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const fundingRequest = async ({ url, onSuccess }) => {
    if (window.confirm('Are you sure?')) {
      setSpinner(true);

      const token = await getAccessTokenSilently();

      if (!token) {
        return;
      }

      const config = {
        token,
        url: `${apiOriginFunding}/${url}`,
        method: 'POST',
        data: JSON.stringify({ fundingId }),
      };

      try {
        await makeRequest(config);
        await refreshFunding(fundingId);

        onSuccess?.();
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }
  };

  return (
    <div className="d-flex align-items-center gap-3">
      {fundingStatus === 'CLOSING' && (
        <Button
          className="bo-common-inline-button text-nowrap"
          onClick={() => fundingRequest({ url: 'close_closing_funding' })}
        >
          Close
        </Button>
      )}
      <Button
        className="bo-common-inline-button text-nowrap"
        onClick={() =>
          fundingRequest({
            url:
              fundingStatus === 'DEFAULT' || fundingStatus === 'CLOSED' ? 'reopen' : 'set_default',
            onSuccess: () =>
              toast.success(
                fundingStatus === 'DEFAULT' || fundingStatus === 'CLOSED'
                  ? 'Repayment status successfully reopened'
                  : 'Repayment status successfully set to DEFAULT',
              ),
          })
        }
      >
        {fundingStatus === 'DEFAULT' || fundingStatus === 'CLOSED' ? 'Re-open' : 'Set as Default'}
      </Button>
      {STATUS_BADGE[fundingStatus] && (
        <Badge className="bo-common-inline-badge" bg={STATUS_BADGE[fundingStatus]?.color}>
          {STATUS_BADGE[fundingStatus]?.text}
        </Badge>
      )}
    </div>
  );
}

export default NewFundingStatusForm;
